import {Directive, ElementRef, HostListener} from '@angular/core';
import {KeyboardService} from "@app/services/keyboard.service";

@Directive({
  selector: '[appJustNumbers]'
})
export class JustNumbersDirective {
  private regex = /^-?\d*\.?\d*$/;  // Permite números, punto y signo negativo
  constructor(private el: ElementRef,
              private keyboardService: KeyboardService,) {}

  @HostListener('input', ['$event'])
  onInputChange(event: Event) {
    const currentValue = this.el.nativeElement?.controls?.value ?? this.el.nativeElement.value;
    // Si el valor no coincide con la expresión regular, lo corrige
    if (!this.regex.test(currentValue)) {
      // Elimina caracteres no válidos
      const sanitizedValue = currentValue.replace(/[^\d.-]/g, '');

      this.el.nativeElement.value = sanitizedValue;

      this.keyboardService.UpdateCursorPosition(
        this.el.nativeElement
      );
    }
  }

}
